module.exports = __webpack_public_path__ + "static/media/howItWorks1-mobile.ef9398ea.png";